import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a526bd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = {
  key: 0,
  class: "has-text-centered p-5"
}
const _hoisted_5 = {
  key: 1,
  class: "has-text-centered p-4"
}
const _hoisted_6 = { class: "has-text-danger mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "step-banner step-banner--warning"
}
const _hoisted_8 = { class: "step-banner__heading" }
const _hoisted_9 = { class: "step-banner__text" }
const _hoisted_10 = {
  key: 1,
  class: "step-banner step-banner--success"
}
const _hoisted_11 = { class: "step-banner__heading" }
const _hoisted_12 = { class: "step-banner__text" }
const _hoisted_13 = { class: "table is-fullwidth is-hoverable list-table result-table" }
const _hoisted_14 = { class: "owner-cell" }
const _hoisted_15 = { class: "status-cell" }
const _hoisted_16 = { class: "owner-cell" }
const _hoisted_17 = { class: "status-cell" }
const _hoisted_18 = {
  key: 0,
  class: "status-tag status-tag--approved"
}
const _hoisted_19 = ["title"]
const _hoisted_20 = {
  key: 2,
  class: "pagination is-centered",
  role: "navigation"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "pagination-list" }
const _hoisted_24 = {
  key: 0,
  class: "pagination-ellipsis"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "step-banner step-banner--brand" }
const _hoisted_27 = { class: "step-banner__heading" }
const _hoisted_28 = { class: "step-banner__text" }
const _hoisted_29 = { class: "table is-fullwidth is-hoverable list-table" }
const _hoisted_30 = { class: "owner-cell" }
const _hoisted_31 = { class: "owner-cell" }
const _hoisted_32 = {
  key: 0,
  class: "pagination is-centered",
  role: "navigation"
}
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "pagination-list" }
const _hoisted_36 = {
  key: 0,
  class: "pagination-ellipsis"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 0,
  class: "step-banner step-banner--danger"
}
const _hoisted_39 = { class: "step-banner__text" }
const _hoisted_40 = { class: "table is-fullwidth is-hoverable" }
const _hoisted_41 = { class: "checkbox-cell" }
const _hoisted_42 = ["title", "checked"]
const _hoisted_43 = { class: "owner-cell" }
const _hoisted_44 = { class: "checkbox-cell" }
const _hoisted_45 = ["checked", "onChange"]
const _hoisted_46 = { class: "owner-cell" }
const _hoisted_47 = {
  key: 1,
  class: "pagination is-centered",
  role: "navigation"
}
const _hoisted_48 = ["disabled"]
const _hoisted_49 = ["disabled"]
const _hoisted_50 = { class: "pagination-list" }
const _hoisted_51 = {
  key: 0,
  class: "pagination-ellipsis"
}
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["disabled"]
const _hoisted_54 = ["disabled"]
const _hoisted_55 = ["disabled"]
const _hoisted_56 = ["disabled"]

import { computed, onMounted, Ref, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import CustomModal from '@/components/CustomModal.vue';
import MemberAvatar from '@/components/MemberAvatar.vue';
import { formatDateTime } from '@/helpers/formatter';
import {
    BULK_APPROVE_PAGE_SIZE,
    BulkApproveAnalysis,
    BulkApproveResultRow,
    useBulkApproveStore,
} from '@/stores/bulk-approve.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkApproveModal',
  props: {
    litigationId: {}
  },
  emits: ["close", "approved"],
  setup(__props: any, { emit }) {

const props = __props;





const { t } = useI18n();
const store = useBulkApproveStore();

const showConfirmPrompt: Ref<boolean> = ref(false);
const resultPage: Ref<number> = ref(1);
const reviewPage: Ref<number> = ref(1);

const currentPageIds = computed((): string[] => store.analyses.map((analysis) => analysis.analysisId));

const allPageSelected = computed(
    (): boolean => currentPageIds.value.length > 0 && currentPageIds.value.every((id) => store.isSelected(id)),
);

// Condensed page list (1 … current-1 current current+1 … last), shared by both views so
// the result screen paginates identically to the analyses list.
const buildPageNumbers = (current: number, total: number): (number | string)[] => {
    const pages: (number | string)[] = [];

    for (let page = 1; page <= total; page += 1) {
        if (page === 1 || page === total || (page >= current - 1 && page <= current + 1)) {
            pages.push(page);
        } else if (pages[pages.length - 1] !== '...') {
            pages.push('...');
        }
    }

    return pages;
};

const totalPages = computed((): number => Math.ceil(store.total / BULK_APPROVE_PAGE_SIZE));

const pageNumbers = computed((): (number | string)[] => buildPageNumbers(store.currentPage, totalPages.value));

// The result list can span every submitted analysis, so it is paginated client-side.
const resultTotalPages = computed((): number => Math.ceil(store.resultRows.length / BULK_APPROVE_PAGE_SIZE));

const resultPageNumbers = computed((): (number | string)[] =>
    buildPageNumbers(resultPage.value, resultTotalPages.value),
);

const pagedResults = computed((): BulkApproveResultRow[] => {
    const start = (resultPage.value - 1) * BULK_APPROVE_PAGE_SIZE;
    return store.resultRows.slice(start, start + BULK_APPROVE_PAGE_SIZE);
});

// Confirmation step: review just the selected analyses, paginated the same way.
const reviewTotalPages = computed((): number => Math.ceil(store.selectedAnalyses.length / BULK_APPROVE_PAGE_SIZE));

const reviewPageNumbers = computed((): (number | string)[] =>
    buildPageNumbers(reviewPage.value, reviewTotalPages.value),
);

const pagedReview = computed((): BulkApproveAnalysis[] => {
    const start = (reviewPage.value - 1) * BULK_APPROVE_PAGE_SIZE;
    return store.selectedAnalyses.slice(start, start + BULK_APPROVE_PAGE_SIZE);
});

const onToggleAll = (checked: boolean): void => {
    store.setPageSelection(currentPageIds.value, checked);
};

const goToPage = (page: number): void => {
    if (page < 1 || page > totalPages.value || page === store.currentPage) {
        return;
    }
    store.fetchPage(props.litigationId, page);
};

const goToResultPage = (page: number): void => {
    if (page < 1 || page > resultTotalPages.value) {
        return;
    }
    resultPage.value = page;
};

const goToReviewPage = (page: number): void => {
    if (page < 1 || page > reviewTotalPages.value) {
        return;
    }
    reviewPage.value = page;
};

const openConfirm = (): void => {
    reviewPage.value = 1;
    showConfirmPrompt.value = true;
};

const confirmApproval = async (): Promise<void> => {
    showConfirmPrompt.value = false;
    resultPage.value = 1;
    await store.submit();
    // Any approvals landed server-side, so refresh the underlying list while the user
    // reviews the result screen.
    if (store.approvedCount > 0) {
        emit('approved');
    }
};

const closeResult = (): void => {
    emit('close');
};

onMounted(() => {
    store.clear();
    store.fetchPage(props.litigationId, 1);
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(CustomModal, {
    width: "70%",
    "min-width": "min(780px, 98vw)",
    onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('close')))
  }, _createSlots({
    "modal-header": _withCtx(() => [
      (_unref(store).submitted)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(store).isPartialFailure ? _unref(t)('bulkApprove.partialTitle') : _unref(t)('bulkApprove.allApprovedTitle')), 1))
        : (showConfirmPrompt.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(t)('bulkApprove.reviewTitle')), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(t)('bulkApprove.title', { count: _unref(store).selectedCount })), 1))
    ]),
    default: _withCtx(() => [
      (_unref(store).loading || _unref(store).submitting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_font_awesome_icon, {
              icon: "spinner",
              size: "2x",
              pulse: ""
            })
          ]))
        : (_unref(store).error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)('bulkApprove.loadError')), 1),
              _createElementVNode("button", {
                class: "button is-radius-small has-text-weight-semibold",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }, _toDisplayString(_unref(t)('common.close')), 1)
            ]))
          : (_unref(store).submitted)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_unref(store).isPartialFailure)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "triangle-exclamation",
                        class: "step-banner__icon"
                      }),
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)('bulkApprove.partialTitle')), 1),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('bulkApprove.partialSummary', {
                                approved: _unref(store).approvedCount,
                                failed: _unref(store).failedCount,
                            })), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "check-circle",
                        class: "step-banner__icon"
                      }),
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)('bulkApprove.allApprovedTitle')), 1),
                        _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)('bulkApprove.allApproved', { count: _unref(store).approvedCount })), 1)
                      ])
                    ])),
                _createElementVNode("table", _hoisted_13, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, _toDisplayString(_unref(t)('listAnalyses.fileName')), 1),
                      _createElementVNode("th", _hoisted_14, _toDisplayString(_unref(t)('listAnalyses.analyzedBy')), 1),
                      _createElementVNode("th", null, _toDisplayString(_unref(t)('listAnalyses.lastModifiedDate')), 1),
                      _createElementVNode("th", _hoisted_15, _toDisplayString(_unref(t)('bulkApprove.status')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pagedResults.value, (row) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: row.analysisId
                      }, [
                        _createElementVNode("td", null, _toDisplayString(row.fileName), 1),
                        _createElementVNode("td", _hoisted_16, [
                          (row.owner)
                            ? (_openBlock(), _createBlock(MemberAvatar, {
                                key: 0,
                                member: row.owner
                              }, null, 8, ["member"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(_unref(formatDateTime)(row.updatedAt)), 1),
                        _createElementVNode("td", _hoisted_17, [
                          (row.approved)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                _createVNode(_component_font_awesome_icon, { icon: "check" }),
                                _createTextVNode(" " + _toDisplayString(_unref(t)('bulkApprove.approvedStatus')), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: "status-tag status-tag--failed",
                                title: _unref(t)(`bulkApprove.reasons.${row.reason}`)
                              }, _toDisplayString(_unref(t)(`bulkApprove.reasonsShort.${row.reason}`)), 9, _hoisted_19))
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                (resultTotalPages.value > 1)
                  ? (_openBlock(), _createElementBlock("nav", _hoisted_20, [
                      _createElementVNode("a", {
                        class: "pagination-previous",
                        disabled: resultPage.value <= 1,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (goToResultPage(resultPage.value - 1)))
                      }, " ‹ ", 8, _hoisted_21),
                      _createElementVNode("a", {
                        class: "pagination-next",
                        disabled: resultPage.value >= resultTotalPages.value,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (goToResultPage(resultPage.value + 1)))
                      }, " › ", 8, _hoisted_22),
                      _createElementVNode("ul", _hoisted_23, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultPageNumbers.value, (page, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, [
                            (page === '...')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, "…"))
                              : (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  class: _normalizeClass(["pagination-link", { 'is-current': page === resultPage.value }]),
                                  onClick: ($event: any) => (goToResultPage(page as number))
                                }, _toDisplayString(page), 11, _hoisted_25))
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (showConfirmPrompt.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "check-circle",
                      class: "step-banner__icon"
                    }),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(t)('bulkApprove.reviewHeading', { count: _unref(store).selectedCount })), 1),
                      _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(t)('bulkApprove.reviewIntro')), 1)
                    ])
                  ]),
                  _createElementVNode("table", _hoisted_29, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_unref(t)('listAnalyses.fileName')), 1),
                        _createElementVNode("th", _hoisted_30, _toDisplayString(_unref(t)('listAnalyses.analyzedBy')), 1),
                        _createElementVNode("th", null, _toDisplayString(_unref(t)('listAnalyses.lastModifiedDate')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pagedReview.value, (analysis) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: analysis.analysisId
                        }, [
                          _createElementVNode("td", null, _toDisplayString(analysis.fileName), 1),
                          _createElementVNode("td", _hoisted_31, [
                            (analysis.owner)
                              ? (_openBlock(), _createBlock(MemberAvatar, {
                                  key: 0,
                                  member: analysis.owner
                                }, null, 8, ["member"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_unref(formatDateTime)(analysis.updatedAt)), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  (reviewTotalPages.value > 1)
                    ? (_openBlock(), _createElementBlock("nav", _hoisted_32, [
                        _createElementVNode("a", {
                          class: "pagination-previous",
                          disabled: reviewPage.value <= 1,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (goToReviewPage(reviewPage.value - 1)))
                        }, " ‹ ", 8, _hoisted_33),
                        _createElementVNode("a", {
                          class: "pagination-next",
                          disabled: reviewPage.value >= reviewTotalPages.value,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (goToReviewPage(reviewPage.value + 1)))
                        }, " › ", 8, _hoisted_34),
                        _createElementVNode("ul", _hoisted_35, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reviewPageNumbers.value, (page, index) => {
                            return (_openBlock(), _createElementBlock("li", { key: index }, [
                              (page === '...')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_36, "…"))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: _normalizeClass(["pagination-link", { 'is-current': page === reviewPage.value }]),
                                    onClick: ($event: any) => (goToReviewPage(page as number))
                                  }, _toDisplayString(page), 11, _hoisted_37))
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  (_unref(store).submitError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "triangle-exclamation",
                          class: "step-banner__icon"
                        }),
                        _createElementVNode("p", _hoisted_39, _toDisplayString(_unref(t)('bulkApprove.submitError')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("table", _hoisted_40, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_41, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            title: _unref(t)('bulkApprove.selectAll'),
                            checked: allPageSelected.value,
                            onChange: _cache[5] || (_cache[5] = ($event: any) => (onToggleAll(($event.target as HTMLInputElement).checked)))
                          }, null, 40, _hoisted_42)
                        ]),
                        _createElementVNode("th", null, _toDisplayString(_unref(t)('listAnalyses.fileName')), 1),
                        _createElementVNode("th", _hoisted_43, _toDisplayString(_unref(t)('listAnalyses.analyzedBy')), 1),
                        _createElementVNode("th", null, _toDisplayString(_unref(t)('listAnalyses.lastModifiedDate')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).analyses, (analysis) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: analysis.analysisId
                        }, [
                          _createElementVNode("td", _hoisted_44, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: _unref(store).isSelected(analysis.analysisId),
                              onChange: ($event: any) => (_unref(store).toggleOne(analysis.analysisId))
                            }, null, 40, _hoisted_45)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(analysis.fileName), 1),
                          _createElementVNode("td", _hoisted_46, [
                            (analysis.owner)
                              ? (_openBlock(), _createBlock(MemberAvatar, {
                                  key: 0,
                                  member: analysis.owner
                                }, null, 8, ["member"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_unref(formatDateTime)(analysis.updatedAt)), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  (totalPages.value > 1)
                    ? (_openBlock(), _createElementBlock("nav", _hoisted_47, [
                        _createElementVNode("a", {
                          class: "pagination-previous",
                          disabled: _unref(store).currentPage <= 1,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (goToPage(_unref(store).currentPage - 1)))
                        }, " ‹ ", 8, _hoisted_48),
                        _createElementVNode("a", {
                          class: "pagination-next",
                          disabled: _unref(store).currentPage >= totalPages.value,
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (goToPage(_unref(store).currentPage + 1)))
                        }, " › ", 8, _hoisted_49),
                        _createElementVNode("ul", _hoisted_50, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageNumbers.value, (page, index) => {
                            return (_openBlock(), _createElementBlock("li", { key: index }, [
                              (page === '...')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_51, "…"))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: _normalizeClass(["pagination-link", { 'is-current': page === _unref(store).currentPage }]),
                                    onClick: ($event: any) => (goToPage(page as number))
                                  }, _toDisplayString(page), 11, _hoisted_52))
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
    ]),
    _: 2
  }, [
    (!_unref(store).loading && !_unref(store).submitting && !_unref(store).error)
      ? {
          name: "modal-footer",
          fn: _withCtx(() => [
            (_unref(store).submitted)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button is-primary is-radius-small has-text-weight-semibold",
                  onClick: closeResult
                }, _toDisplayString(_unref(t)('bulkApprove.done')), 1))
              : (showConfirmPrompt.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("button", {
                      class: "button is-radius-small has-text-weight-semibold mr-2",
                      disabled: _unref(store).submitting,
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (showConfirmPrompt.value = false))
                    }, _toDisplayString(_unref(t)('bulkApprove.cancel')), 9, _hoisted_53),
                    _createElementVNode("button", {
                      class: "button is-primary is-radius-small has-text-weight-semibold",
                      disabled: _unref(store).submitting,
                      onClick: confirmApproval
                    }, _toDisplayString(_unref(t)('bulkApprove.confirmAction')), 9, _hoisted_54)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("button", {
                      class: "button is-radius-small has-text-weight-semibold mr-2",
                      disabled: _unref(store).submitting,
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('close')))
                    }, _toDisplayString(_unref(t)('common.close')), 9, _hoisted_55),
                    _createElementVNode("button", {
                      class: "button is-primary is-radius-small has-text-weight-semibold",
                      disabled: _unref(store).selectedCount === 0 || _unref(store).submitting,
                      onClick: openConfirm
                    }, _toDisplayString(_unref(t)('bulkApprove.confirm', { count: _unref(store).selectedCount })), 9, _hoisted_56)
                  ], 64))
          ]),
          key: "0"
        }
      : undefined
  ]), 1024))
}
}

})